import React, { useContext, useState } from "react";
import { PatentContext } from "../context/PatentContextProvider";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "axios";
import { Country, State, } from "country-state-city";

export const ContactUsModal = () => {
    const domain = window.location.hostname;
    const { register, formState: { errors }, watch, handleSubmit, control, reset } = useForm({ mode: "onBlur" });
    const [countryCode, setCountryCode] = useState(null);
    const [stateCode, setStateCode] = useState(null);
    const countryOptions = Country.getAllCountries().map(c => ({
        value: c.isoCode,
        label: `${c.flag} ${c.name}`
    }))

    const stateOptions = countryCode ? State.getStatesOfCountry(countryCode).map(s => ({
        value: s.isoCode,
        label: s.name
    })) : [];

    const hasStates = (countryCode) =>
        State.getStatesOfCountry(countryCode)?.length > 0;

    const options = Country.getAllCountries().map(c => ({
        value: c.isoCode,
        label: `${c.flag} ${c.name}`
    }));

    const { patentLicensingModal, setPatentLicensingModal } = useContext(PatentContext);
    const onSubmit = async (data) => {
        console.log("data", data)
        const { Name, email, country, state } = data;


        try {
            await axios.post(
                `${process.env.REACT_APP_API_PATH}/api/newsLetter`,
                {
                    Name,
                    email,
                    domain,
                    country: country.label,
                    state: state.label ? state.label : ""
                }
            );

            toast.success("Your request has been successfully submitted!");
            reset();
            setPatentLicensingModal(false);
        } catch (error) {
            console.error("Newsletter submission failed:", error);
            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <>
            {patentLicensingModal && (
                <div className="bg-gray-100 flex items-center justify-center ">
                    {patentLicensingModal && (
                        <div
                            className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-start justify-center z-50 pt-20"
                            onClick={(e) => {
                                if (e.target.id === "modalOverlay") setPatentLicensingModal(false);
                            }}
                            id="modalOverlay"
                        >
                            {/* Modal Container */}
                            <div className="bg-white rounded-lg shadow-lg w-[90%] sm:w-2/3 md:w-1/2 lg:w-1/3 p-4 sm:p-6 relative max-h-[90vh] overflow-y-auto">
                                <button
                                    onClick={() => {
                                        setPatentLicensingModal(false);

                                    }}
                                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                                >
                                    ✖
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-4">
                                    </div>
                                    {/* Modal Body */}
                                    <div class="mb-6">
                                        <input
                                            type="text"
                                            name="Name"
                                            id="Name"
                                            className="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                            {...register("Name", {
                                                required: "Name is required",
                                            })}
                                            placeholder="Enter Name"
                                        />
                                        {errors.Name && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                    paddingTop: "5px",
                                                }}
                                            >
                                                {errors.Name.message}
                                            </small>
                                        )}
                                    </div>
                                    <div class="mb-6">
                                        <input
                                            type="text"
                                            name="email"
                                            id="email"
                                            class="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                                            {...register("email", {
                                                required: "Email is required",
                                                validate: {
                                                    maxLength: (v) =>
                                                        v.length <= 50 ||
                                                        "The email should have at most 50 characters",
                                                    matchPattern: (v) =>
                                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                                            v
                                                        ) || "email address must be a valid address",
                                                },
                                            })}
                                            placeholder="Enter Email"
                                        />
                                        {errors.email && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                }}
                                            >
                                                {errors.email.message}
                                            </small>
                                        )}
                                    </div>
                                    <div className="mb-6">
                                        <Controller
                                            name="country"
                                            control={control}
                                            rules={{ required: "Country is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={countryOptions}
                                                    placeholder="Select Country"
                                                    onChange={(selected) => {
                                                        field.onChange(selected);
                                                        setCountryCode(selected.value);
                                                        setStateCode(null);
                                                    }}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            backgroundColor: "#f9fafb",
                                                            borderColor: errors.country ? "#ef4444" : "#4b5563",
                                                            borderRadius: "0.5rem",
                                                            minHeight: "45px",
                                                            fontSize: "0.875rem",
                                                        }),
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.country && (
                                            <small className="text-red-500 text-xs block mt-1">
                                                {errors.country.message}
                                            </small>
                                        )}
                                    </div>
                                    <div className="mb-6">
                                        <Controller
                                            name="state"
                                            control={control}
                                            rules={{
                                                validate: () => {
                                                    if (!countryCode) return true;
                                                    if (!hasStates(countryCode)) return true;
                                                    return stateCode ? true : "State is required";
                                                },
                                            }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={stateOptions}
                                                    placeholder={
                                                        hasStates(countryCode)
                                                            ? "Select State"
                                                            : "No states available"
                                                    }
                                                    isDisabled={!hasStates(countryCode)}
                                                    onChange={(selected) => {
                                                        field.onChange(selected);
                                                        setStateCode(selected?.value || null);
                                                    }}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            backgroundColor: "#f9fafb",
                                                            borderColor: errors.state ? "#ef4444" : "#4b5563",
                                                            borderRadius: "0.5rem",
                                                            minHeight: "45px",
                                                            fontSize: "0.875rem",
                                                        }),
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.state && (
                                            <small className="text-red-500 text-xs block mt-1">
                                                {errors.state.message}
                                            </small>
                                        )}
                                    </div>
                                    <div className="mb-6">
                                        <label className="flex items-start gap-2 text-sm text-gray-900">
                                            <input
                                                type="checkbox"
                                                className="mt-1"
                                                {...register("emailSubscription", {
                                                    required: "Please agree to receive emails to continue",
                                                })}
                                            />
                                            <span>
                                                Sign up for our email list for updates, promotions, and more.
                                            </span>
                                        </label>

                                        {errors.emailSubscription && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                    paddingTop: "5px",
                                                }}
                                            >
                                                {errors.emailSubscription.message}
                                            </small>
                                        )}
                                    </div>


                                    {/* Modal Footer */}
                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        >
                                            Send
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}